import React from 'react';
import {Skeleton} from '@material-ui/lab';

const ProductsTitle = ({animation = 'wave'}) => {
	return (
		<React.Fragment>
			{/* Title item */}
			<Skeleton
				variant="text"
				width={360}
				height={80}
				animation={animation}
				className={"my-2"}
			/>
		</React.Fragment>
	);
};

export default ProductsTitle;